import {
    DataObject,
    AppendableDataObject,
    dataFactoryInstance
} from "@/v2/models/base-data-object.js";

export class SearchListItem extends DataObject {
    _type = 'search_list_item';

    groupTitle;
    items = [];
}

export class SearchItem extends AppendableDataObject {
    _type = 'search_item';

    value = "";

    hasQuery(query) {
        return this.value.toLowerCase().includes(query);
    }
}

export function constructSearchListItems(data) {
   return data.map((listItemData) => constructSearchListItem(listItemData));
}

export function constructSearchListItem(listItemData) {
    let listItem = dataFactoryInstance.construct(SearchListItem, listItemData);
    if (listItemData.items != null) {
        listItem.items = constructSearchItems(listItemData.items);
    }

    return listItem;
}

export function constructSearchItems(data) {
    return data.map((itemData) => constructSearchItem(itemData));
}

export function constructSearchItem(itemData) {
    return new SearchItem(itemData);
}

export function searchProperties(query) {
    return Object.values(this).filter((value) => typeof value === 'string' || typeof value === 'number').some((value) => {
        if (typeof value === 'string') {
            return value.toLowerCase().includes(query);
        }
        if (typeof value === 'number') {
            return value.toString().toLowerCase().includes(query);
        }
    })
}
